import { render, staticRenderFns } from "./ChainsTab.vue?vue&type=template&id=109fa7ad"
import script from "./ChainsTab.vue?vue&type=script&lang=js"
export * from "./ChainsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports